import {
  HTTP,
  DefaultErrorHandler,
  HMD_BACKEND_API_URL
} from "@/utils/http-common"
import store from "@/store"
import router from "@/router"
import axios from "axios"

export default {
  emailNotReceived(email, $) {
    return new Promise((resolve, reject) => {
      HTTP.post("/account/registration/resend-confirm-email/", {
        email: email
      })
        .then(response => {
          $.$store.commit("success", "E-mail sent")
          resolve(response)
        })
        .catch(error => {
          $.$store.commit("error", {
            msg: error.response.data.error.join("\n"),
            color: "error"
          })
          reject(error)
        })
    })
  },
  profile($) {
    return new Promise((resolve, reject) => {
      HTTP.get("/account/settings/user/")
        .then(r => {
          resolve(r.data)
        })
        .catch(e => {
          $.$store.commit("error", {
            msg: "Request failed: Retrieving user information",
            color: "error"
          })
        })
    })
  },
  updateProfileInfo($, firstName, lastName, username) {
    return new Promise((resolve, reject) => {
      HTTP.put("/account/settings/user/", {
        first_name: firstName,
        last_name: lastName,
        username: username
      })
        .then(function(response) {
          $.$store.state.user.username = username
          $.$store.state.user.first_name = firstName
          $.$store.state.user.last_name = lastName
          $.$store.commit("success", "Profile updated")
          resolve(response)
        })
        .catch(function(error) {
          var err = error.response.data
          for (var prop in err) {
            $.$store.commit("error", {
              msg: prop + " : " + err[prop],
              color: "error"
            })
          }
          reject(error)
        })
    })
  },
  changePassword($, old, new1, new2) {
    return new Promise((resolve, reject) => {
      HTTP.post("/account/password/change/", {
        new_password1: new1,
        new_password2: new2,
        old_password: old
      })
        .then(function(response) {
          $.$store.commit("success", "Password updated")
          resolve(response)
        })
        .catch(function(error) {
          var err = error.response.data
          for (var prop in err) {
            $.$store.commit("error", {
              msg: prop + " : " + err[prop],
              color: "error"
            })
          }
          reject(error)
        })
    })
  },
  resetPassword(email, $) {
    return new Promise((resolve, reject) => {
      HTTP.post("/account/password/reset/", { email: email })
        .then(response => {
          $.$store.commit(
            "success",
            "An e-mail will be sent if this address is registered"
          )
          resolve(response)
        })
        .catch(error => {
          $.$store.commit("error", { msg: error, color: "error" })
          reject(error)
        })
    })
  },
  sendNewPassword(parent, password1, password2, uid, key) {
    return new Promise((resolve, reject) => {
      HTTP.post("/account/password/reset/confirm/", {
        uid: uid,
        token: key,
        new_password1: password1,
        new_password2: password2
      })
        .then(response => {
          resolve(response)
          parent.$store.commit("success", "Password updated")
          setTimeout(() => {
            parent.$router.replace("/signin")
          }, 1000)
        })
        .catch(error => {
          parent.$store.commit("error", { msg: error, color: "error" })
          reject(error)
        })
    })
  },
  getInvitation(parent, invitation_key) {
    // We don't use HTTP here, because if the invitation is expired, it returns a 401,
    // which after a really short amount of time redirect the user to the login page
    // and don't let him enough time to see the error message.
    return new Promise((resolve, reject) => {
      axios
        .post(HMD_BACKEND_API_URL + "/invitations/get_invitation/", {
          key: invitation_key
        })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
          parent.$store.commit("error", { msg: error, color: "error" })
        })
    })
  },
  acceptInvitation(parent, invitation_key) {
    return new Promise((resolve, reject) => {
      HTTP.post(`/invitations/accept/${invitation_key}/`)
        .then(result => {
          resolve(result)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  login(parent, creds, redirect) {
    return new Promise((resolve, reject) => {
      HTTP.post("/account/login/", {
        email: creds.email,
        password: creds.password,
        recaptchaToken: creds.recaptchaToken
      })
        .then(function(response) {
          store.commit("setUser", response.data)
          store.commit("setNotifications")
          setTimeout(() => {
            if (redirect) router.push(redirect)
            else
              router.push({
                name: "Accueil"
              })
            resolve(response)
          }, 500)
        })
        .catch(e => DefaultErrorHandler(e, reject))
    })
  },
  logout() {
    HTTP.get("/account/logout").finally(() => {
      store.commit("clearSession")
      setTimeout(() => {
        router.push("/signin")
      }, 500)
    })
  },
  register(parent, account) {
    return new Promise((resolve, reject) => {
      HTTP.post("/account/registration", account)
        .then(function(response) {
          router.push("/signup/activation")
        })
        .catch(e => DefaultErrorHandler(e, reject))
    })
  }
}
